<template>
  <div>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog.Add" max-width="600px" @input="AddBanner = []">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" outlined small v-on="on"
          >Tambah Banner <v-icon right dark>mdi-cloud-upload</v-icon></v-btn
        >
      </template>
      <v-form v-model="isValidAdd">
        <v-card>
          <v-toolbar color="#c90000" class="white--text" dense flat>
            <v-toolbar-title><b>Tambah Banner</b></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="(dialog.Add = false), (AddBanner = [])">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Nama*"
                    v-model="AddBanner.Nama"
                    :rules="[v => !!v || 'Nama wajib diisi']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    name="input-7-1"
                    label="Deskripsi*"
                    v-model="AddBanner.Deskripsi"
                    :rules="[v => !!v || 'Deskripsi wajib diisi']"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    :rules="rules"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Pilih foto banner Mobile"
                    prepend-icon="mdi-camera"
                    v-model="AddBanner.Foto"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    :rules="rules"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Pilih foto banner Website"
                    prepend-icon="mdi-camera"
                    v-model="AddBanner.FotoWeb"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" sm="6">
                  <div>
                    Pilih Tipe Banner*
                    <v-select
                      outlined
                      dense
                      v-model="selectType"
                      :items="selected"
                      item-text="nama"
                      item-value="id"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
              <v-radio-group v-model="AddBanner.isHidden">
                <template v-slot:label>
                  <div>Status Banner*</div>
                </template>
                <v-radio label="Tampilkan" :value="false"></v-radio>
                <v-radio label="Sembunyikan" :value="true"></v-radio>
              </v-radio-group>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="dialog.Add = false"
              >Close</v-btn
            >
            <v-btn
              color="teal "
              :disabled="!isValidAdd"
              outlined
              @click="TambahMstBanner()"
              >Tambah</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog  v-model="dialog.Detail" max-width="600px"  @input="UpdateBanner = []">
      <v-form v-model="isValidEdit">
        <v-card>
          <v-toolbar color="#c90000" class="white--text" dense flat>
            <v-toolbar-title><b>Update Banner</b></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="(dialog.Detail = false), (UpdateBanner = [])">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="12">
                  <v-text-field
                    label="Nama*"
                    v-model="ComDetailBanner[0].nama"
                    :rules="[v => !!v || 'Nama wajib diisi']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    name="input-7-1"
                    label="Deskripsi*"
                    v-model="ComDetailBanner[0].deskripsi"
                    :rules="[v => !!v || 'Deskripsi wajib diisi']"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    accept="image/png, image/jpeg, image/bmp"
                    label="Pilih foto banner untuk mobile"
                    prepend-icon="mdi-camera"
                    v-model="UpdateBanner.Foto"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    accept="image/png, image/jpeg, image/bmp"
                    label="Pilih foto banner untuk web"
                    prepend-icon="mdi-camera"
                    v-model="UpdateBanner.FotoWeb"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" sm="6">
                  <div>
                    Pilih Tipe Banner*
                    <v-select
                      outlined
                      dense
                      v-model="ComDetailBanner[0].id_type_banner"
                      :items="selected"
                      item-text="nama"
                      item-value="id"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
              <v-radio-group v-model="ComDetailBanner[0].is_hidden">
                <template v-slot:label>
                  <div>Status Banner*</div>
                </template>
                <v-radio label="Tampilkan" :value="false"></v-radio>
                <v-radio label="Sembunyikan" :value="true"></v-radio>
              </v-radio-group>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red "
              outlined
              @click="(dialog.Detail = false), (UpdateBanner = [])"
              >Close</v-btn
            >
            <v-btn
              color="teal"
              :disabled="!isValidEdit"
              outlined
              @click="UpdateMstBanner()"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog.Delete" max-width="350">
      <v-toolbar>
        <v-card-title>Hapus Banner</v-card-title>
      </v-toolbar>
      <v-card>
        <v-card-text class="py-5"> Apakah anda yakin untuk menghapus banner '<span style="color: green;">{{ ComDetailBanner[0].nama }}</span>' ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red " outlined @click="dialog.Delete = false"
            >Cancel</v-btn
          >
          <v-btn color="teal " outlined @click="DeleteMstBanner">Yess</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Banner
      :units="mst_banner"
      :onDetail="GetDetailMstBanner"
      :onDelete="PreDeleteMstBanner"
      :viewUpdate="viewStatusUpdate"
    />
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
  components: {
    Banner
  },
  data() {
    return {
      selectType: { nama: 'Umum', id: 1 },
      selected: [
        { nama: 'Umum', id: 1 },
        { nama: 'Lelang', id: 5 }
      ],
      ReRender: true,
      dialog: { Detail: false, Add: false, Delete: false },
      UpdateBanner: {
        Nama: null,
        Deskripsi: null,
        Foto: null,
        FotoWeb: null,
        isHidden: null
      },
      AddBanner: {
        Nama: null,
        Deskripsi: null,
        Foto: null,
        FotoWeb: null,
        isHidden: true
      },
      cycle: false,
      mst_banner: null,
      color: { snackbar: '' },
      snackbar: false,
      message: null,
      DetailBanner: [{}],
      rules: [
        v => !!v || 'Foto wajib diisi',
        v =>
          (v && v.size < 1000000) ||
          'Gambar banner tidak boleh lebih dari 1 MB!'
      ],
      users: [],
      isValidEdit: true,
      isValidAdd: true
    };
  },
  mounted() {
    this.GetMstBanner();
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
  },
  methods: {
    forceRerender() {
      this.ReRender = false;
      this.$nextTick(() => {
        this.ReRender = true;
      });
    },
    viewStatusUpdate(item) {
      this.ComDetailBanner[0].id = item.id;
      this.ComDetailBanner[0].nama = item.nama;
      this.ComDetailBanner[0].deskripsi = item.deskripsi;
      this.ComDetailBanner[0].is_hidden = item.is_hidden;
      this.ComDetailBanner[0].id_type_banner = item.id_type_banner;
      this.UpdateMstBanner();
    },
    async Reload() {
      this.GetMstBanner();
      this.forceRerender();
    },
    async GetMstBanner() {
      await this.$req
        .get(this.$root.$baseapi.master+'/master/v3/mst_banner_admin', {
          params: {
            limit: 99
          }
        })
        .then(response => {
          this.mst_banner = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    async GetDetailMstBanner(id) {
      this.$req
        .get(this.$root.$baseapi.master+'/master/v3/mst_banner_admin', {
          params: {
            id: id
          }
        })
        .then(response => {
          this.DetailBanner = response.data.data;
          this.dialog.Detail = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async UpdateMstBanner() {
      console.log(this.ComDetailBanner[0].is_hidden);
      let formData = new FormData();
      formData.append('id', this.ComDetailBanner[0].id);
      formData.append('nama', this.ComDetailBanner[0].nama);
      formData.append('deskripsi', this.ComDetailBanner[0].deskripsi);
      formData.append('is_hidden', this.ComDetailBanner[0].is_hidden);
      if (typeof this.ComDetailBanner[0].id_type_banner == 'object') {
        formData.append(
          'id_type_banner',
          this.ComDetailBanner[0].id_type_banner.id
        );
      } else {
        formData.append(
          'id_type_banner',
          this.ComDetailBanner[0].id_type_banner
        );
      }

      if (this.UpdateBanner.Foto != null) {
        formData.append('foto', this.UpdateBanner.Foto);
      }
      if (this.UpdateBanner.FotoWeb != null) {
        formData.append('foto_web', this.UpdateBanner.FotoWeb);
      }
      const resp = await this.$req
        .put(this.$root.$baseapi.master+'/master/v3/mst_banner', formData)
        .then(function(response) {
          return response;
        })
        .catch(error => {
          return error.response;
        });

      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.dialog.Detail = false;
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }

      this.UpdateBanner.Foto = null;
      this.snackbar = true;

      this.Reload();
    },
    async TambahMstBanner() {
      let formData = new FormData();
      formData.append('nama', this.AddBanner.Nama);
      formData.append('deskripsi', this.AddBanner.Deskripsi);
      formData.append('foto', this.AddBanner.Foto);
      formData.append('foto_web', this.AddBanner.FotoWeb);
      formData.append('id_biz_user', this.users.id);
      formData.append('id_type_banner', this.selectType.id);
      formData.append('is_hidden', this.AddBanner.isHidden);

      const resp = await this.$req
        .post(this.$root.$baseapi.master+'/master/v3/mst_banner', formData)
        .then(function(response) {
          // this.AddBanner = [];
          return response;
        })
        .catch(error => {
          return error.response;
        });

      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.Reload();
        this.dialog.Add = false;
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }
      this.AddBanner = [];
      this.snackbar = true;
    },
    async PreDeleteMstBanner(id) {
      this.$req
        .get(this.$root.$baseapi.master+'/master/v3/mst_banner_admin', {
          params: {
            id: id
          }
        })
        .then(response => {
          this.DetailBanner = response.data.data;
          this.dialog.Delete = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async DeleteMstBanner() {
      const resp = await this.$req
        .delete(this.$root.$baseapi.master+'/master/v3/mst_banner', {
          params: {
            id: this.ComDetailBanner[0].id
          }
        })
        .then(function(response) {
          return response;
        })
        .catch(error => {
          return error.response;
        });

      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.Reload();
        this.dialog.Delete = false;
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }

      this.snackbar = true;

      //   this.Reload();
    }
  },
  computed: {
    ComDetailBanner: {
      get: function() {
        return this.DetailBanner;
      },
      set: function(newValue) {
        this.DetailBanner = newValue;
      }
    }
  }
};
</script>
